import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileCTA from "./MobileCTA";

export default function Layout({ children }) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-metal">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <MobileCTA />
        </div>
    );
}
